/** Builds a key that is a number because it plays nicely with snakeCaseDeep + camelCaseDeep when used as an object key */
export function getUniqueId(): string {
  return `${Math.random()}`.slice(2).padEnd(25, `${Date.now()}`);
}
